module.exports = __webpack_public_path__ + "img/graphic3.7d7d45c6.png";